import { render } from "./UserDropdown.vue?vue&type=template&id=6deea2cf&scoped=true&ts=true"
import script from "./UserDropdown.vue?vue&type=script&lang=ts"
export * from "./UserDropdown.vue?vue&type=script&lang=ts"

import "./user-dropdown.scss?vue&type=style&index=0&id=6deea2cf&lang=scss&scoped=true"
import "./user-dropdown-global.scss?vue&type=style&index=1&lang=scss"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6deea2cf"]])

export default __exports__